import React, { useContext, useEffect, useRef, useState } from "react";
import { Layout, Input, Form, Row, Col, Button, Alert, Spin, Space, Typography, Divider, message } from 'antd';
import constants from '../../../constants/constants';
import logo from '../../../hire-logo-v2.svg';
import APIUtils from '../../../api/APIUtils';
import WebLinks from '../../../api/WebLinks';
import { useAuth } from '../../../services/AuthService';
import Cookies from "js-cookie";
import BottomLeftScribble from '../../../assets/vectors/bottom-left-scribble.svg';
import TopRightScribble from '../../../assets/vectors/top-right-scribble.svg';
import LoginArt from '../../../assets/vectors/login-graphic.svg'
import useTurnstile from "./useTurnstile";
import { CommonContext } from "../../../Context";

const { Content } = Layout;
const siteKey =
window.location.hostname === 'localhost'
	? '1x00000000000000000000AA'
	: process.env.REACT_APP_TURNSTILE_SITE_KEY;

const Login = () => {
	useTurnstile();
	const { loginAuth } = useAuth();
	const commonContext=useContext(CommonContext);
	const [isLoading, setIsLoading] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [alertType, setalertType] = useState('');
	const [showAlert, setShowAlert] = useState(false);
	const [showOTPField,setShowOTPField]=useState(false);
	const [timeLeft, setTimeLeft] = useState(300); // 5 minutes
  const [showReset, setShowReset] = useState(true);
	const [responseData,setResponseData]=useState(null);
	const [form] = Form.useForm();
	const [forgotPasswordForm] = Form.useForm();
	const [showForgotPassword, setShowForgotPassword] = useState(false);
	const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
	const forgotPasswordSubmitLock = useRef(false);

	const showMessage = (message, type) => {
		setAlertMessage(message);
		setalertType(type);
		setShowAlert(true);
		// setTimeout(hideMessage, 2000);
	};

	const showErrorMessage = () => {
		showMessage(constants.ERROR_MESSAGE, 'error')
	};
	const onFinish = async (values) => {
		setShowAlert(false);
		if(values.password){
			const token = document.querySelector('input[name="cf-turnstile-response"]')?.value;
			setIsLoading(true)
			let body = JSON.stringify({ userName: values.email, password: values.password , turnstileToken: token});//
			let response = await APIUtils.apiCall("POST", WebLinks.Login, body, false);
			if (response.isCatch) {
				showErrorMessage();
				setIsLoading(false);
			} else {
				if(response?.resultObj?.data){
					if(response?.resultObj?.data?.enable2FA===true){
						getOTP(values.email);
						setResponseData(response);
						setShowOTPField(true);
					}else{
					await onLoginAPISucess(response.resultObj)//,values.rememberMe)
					}
				}else{
					showErrorMessage();
				}
				setIsLoading(false);
			}
		}else if(values.OTPPassword){
			VerifyOTPOTP(values.email,values.OTPPassword,responseData)
		}
	};

	const getOTP= async(email)=>{
		let body= JSON.stringify(email);
		let response= await APIUtils.apiCall("POST",WebLinks.GetOTP,body,false);
		if(response.isCatch && response.resultObj?.statusCode !== "2000"){
			message.error(constants.FAILED_OTP);
		}else{
			setShowReset(false);
			setTimeLeft(300);
			message.success(constants.SUCCESS_OTP_SENT);
		}
	}

	const VerifyOTPOTP= async(email,code)=>{
		let body= JSON.stringify({email:email,code:code});
		let response= await APIUtils.apiCall("POST",WebLinks.VerifyOTP,body,false);
		if(!response.isCatch && response.resultObj?.statusCode === "2000"){
			await onLoginAPISucess(responseData.resultObj)//,values.rememberMe)			
		}else{
			message.error(constants.FAILED_OTP_VERIFFY);
		}
	}

	const onLoginAPISucess = (res) => {
		if (res.statuscode === 2000) {
			loginAuth(res.data.accessToken, true).then(async () => {
				await getBuyerDetails(res.data);
				window.location.href = '/welcome'
			});
		} else {
			showMessage(res && res.Message ? res.Message : constants.ERROR_MESSAGE, 'error');
			setIsLoading(false);
		}
	};

	const getBuyerDetails = async (data) => {
		commonContext.changeCommonValues({'buyerId':data.id});
		//set logged in and selected buyer cookies
		Cookies.set(constants.COOKIE_LOGGED_BUYER_ID, data.id, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
		Cookies.set(constants.COOKIE_LOGGED_BUYER_NAME, data.userName, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
		Cookies.set(constants.COOKIE_LOGGED_BUYER_SELF_POSTED, data.selfPosted, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
		sessionStorage.setItem('selectedbuyername', data.userName);
		Cookies.set(constants.COOKIE_IS_ADMIN, data.hireIntelligenceAdmin, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
		Cookies.set(constants.COOKIE_IS_SUPERADMIN, data.hiSuperAdmin, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
		Cookies.set(constants.COOKIE_IS_CS_ADMIN, data.hiCSAdmin, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
		Cookies.set(constants.COOKIE_CANDIDATE_TAB, data.hIHideCandidateTab, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
		await sessionStorage.setItem('selectedbuyerselfpost', data.selfPosted);
		await sessionStorage.setItem('emailpost', data.emailPost);
		await sessionStorage.setItem('selectedissubbuyeradmin', data.subBuyerAdmin);
		Cookies.set(constants.COOKIE_LOGGEDIN_IS_SUB_BUYER_ADMIN, data.subBuyerAdmin, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
		Cookies.set(constants.COOKIE_IS_RECRUITER, data.recruiter, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
		await sessionStorage.setItem('isSelfService', data.selfService);
		Cookies.set(constants.COOKIE_IS_SELFSERVICE, data.selfService, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
		await sessionStorage.setItem('isBoost', data.showBoost);
		Cookies.set(constants.COOKIE_IS_FINANCE, data.hireIntelligenceFinance, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });
		Cookies.set(constants.COOKIE_HIRE_INTELLIGENCE_USER, data.hireIntelligenceUser, { path: '/', expires: constants.COOKIE_EXPIRY_DAYS });

		setIsLoading(false)
	};

  useEffect(() => {
    if (timeLeft <= 0) {
      setShowReset(true);
      return;
    }
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

	const ResendOTP=()=>{
		let emailEnter= form.getFieldValue('email');
		if(emailEnter){
			getOTP(emailEnter)
		}else{
			message.error(constants.LoginEmailValid);
		}
	}

	const openForgotPassword = () => {
		forgotPasswordForm.setFieldsValue({ email: form.getFieldValue('email') });
		setShowAlert(false);
		setShowForgotPassword(true);
	};

	const cancelForgotPassword = () => {
		forgotPasswordForm.resetFields();
		setShowForgotPassword(false);
	};

	const onForgotPasswordSubmit = async (values) => {
		if (forgotPasswordSubmitLock.current) return;
		forgotPasswordSubmitLock.current = true;
		console.log('Forgot Password Form Values:', values);
		setForgotPasswordLoading(true);
		try {
			const body = JSON.stringify({ emailId: values.email });
			const response = await APIUtils.apiCall("POST", WebLinks.ResendPasswordOTP, body, false);
			if (!response.isCatch && response.resultObj?.statusCode === "2000") {
				message.success(response.resultObj?.message);
				setShowForgotPassword(false);
			} else {
				setShowForgotPassword(false);
				message.error(response.resultObj?.message);
			}
		} catch {
			message.error(constants.ERROR_MESSAGE);
		} finally {
			forgotPasswordSubmitLock.current = false;
			setForgotPasswordLoading(false);
		}
	};
	return (
		<Spin spinning={isLoading}>
			<div>
				<img src={BottomLeftScribble} alt="left-scribble" className="absolute bottom-0 left-0 z-10 xl:w-1/6 min-[1440px]:w-auto" />
				<img src={TopRightScribble} alt="top-scribble" className="absolute top-0 right-0 z-10" />
				<Layout>
					<Content className="relative">
						<Row className='h-screen'>
							<Col xs={24} lg={10} xxl={9} className="bg-[#286C68] relative">
								<div className="w-5/6 lg:w-9/12 relative z-20 mx-auto">
									<img src={logo} alt="Logo" width={215} className="absolute top-0 pt-7 2xl:pt-16" />
								</div>
								<div className="w-5/6 lg:w-9/12 h-full relative z-20 mx-auto flex place-items-center">
									<div className="w-full">
										{showForgotPassword ? (
											<>
												<h1 className="font-semibold text-xl text-white mb-1">FORGOT YOUR PASSWORD?</h1>
												<p className="text-sm text-white mb-4">Not to worry, we got you! Let's get you a new password.</p>
											</>
										) : (
											<h1 className="font-semibold text-xl text-white mb-4">Log in to Hire Intelligence</h1>
										)}
										{showForgotPassword ? (
											<Form form={forgotPasswordForm} layout="vertical" requiredMark={false} onFinish={onForgotPasswordSubmit}>
												<Form.Item
													label={<span className='text-white uppercase'>{constants.Email}</span>}
													name="email"
													rules={[
														{ type: 'email', required: true, message: constants.LoginEmailValid },
													]}
												>
													<Input autoFocus size="large" placeholder={constants.Email} />
												</Form.Item>
												<div className="flex justify-end gap-3">
													<Button size="large" onClick={cancelForgotPassword} className="bg-[#0C2C2A] border-[#0C2C2A] text-white">Cancel</Button>
													<Button size="large" htmlType="submit" loading={forgotPasswordLoading} className='bg-[#0C2C2A] border-[#0C2C2A] text-white'>Send</Button>
												</div>
											</Form>
										) : (
										<Form form={form}  layout="vertical" requiredMark={false} onFinish={(e) => onFinish(e)}>
											{showAlert ? <Alert className="alert" message={alertMessage} type={alertType} closable showIcon /> : null}
											<Form.Item
												label={<span className='text-white uppercase'>{constants.Email}</span>}
												name="email"
												rules={[
													{
														type: 'email',
														required: true,
														message: constants.LoginEmailValid,
													},
												]}
											>
												<Input autoFocus size="large" placeholder={constants.Email} />
											</Form.Item>
											
											{showOTPField === true ? (
												<Form.Item
													label={<span className='text-white uppercase'>{constants.OTPPassword}</span>}
													name="OTPPassword"
													rules={[
														{
															required: true,
															message: constants.OTPValid,
														},
													]}
												>
													<Input.Password
														placeholder={constants.OTPPassword}
														size="large"
													/>
												</Form.Item>
											) : (
												<Form.Item
													label={<span className='text-white uppercase'>{constants.Password}</span>}
													name="password"
													rules={[
														{
															required: true,
															message: constants.LoginPasswordValid,
														},
													]}
												>
													<Input.Password
														placeholder={constants.Password}
														size="large"
													/>
												</Form.Item>
											)}
											<div className="-mt-5 mb-3 flex justify-end">
												<Button type="link" onClick={openForgotPassword} className="!px-0 !text-white hover:!text-yellow-200">
													Forgot password?
												</Button>
											</div>
											{showOTPField===true?<>
											<div className="text-right mb-3">{showReset? <a onClick={()=>{ResendOTP()}}><span className="text-white">Resend OTP</span></a>:<span className="text-white">OTP Expires in {formatTime(timeLeft)}</span>}</div>
											<Form.Item>
												<Button size="large" shape="round" block htmlType="submit" className='bg-[#0C2C2A] border-[#0C2C2A] text-white'>
													{constants.Continue}
													</Button>
											</Form.Item></>
											:<>
												{/* Turnstile widget */}
												<div
													className="cf-turnstile"
													data-sitekey={siteKey}
													data-theme="dark"
												></div>
												<Form.Item>
													<Button size="large" shape="round" block htmlType="submit" className='bg-[#0C2C2A] border-[#0C2C2A] text-white'>
														{constants.Login}
													</Button>
												</Form.Item>
											</>} 	
											</Form>
											)}
									</div>
								</div>
							</Col>
							<Col xs={24} lg={14} xxl={15} className="bg-[#0C2C2A] hidden lg:flex justify-center items-center relative">
								<img src={LoginArt} alt="login-vector" className="w-[55%] min-[1440px]:w-[75%] 2xl:w-[55%] mx-auto hidden lg:block" />
							</Col>
						</Row>
						<div className="absolute bottom-0 inset-x-0 lg:left-auto lg:right-6 z-20 p-2.5 justify-center bg-[#0C2C2A] lg:bg-transparent">
							<Space wrap split={<Divider type="vertical" className="!border-white" />}>
								<Typography.Link className="!text-white hover:!text-yellow-200" onClick={() => window.open('/data-policy', '_blank')}>Data Policy</Typography.Link>
								<Typography.Link className="!text-white hover:!text-yellow-200" onClick={() => window.open('/terms-and-conditions', '_blank')}>Terms and Conditions</Typography.Link>
								<Typography.Link className="!text-white hover:!text-yellow-200" onClick={() => window.open('/privacy-policy', '_blank')}>Privacy Policy</Typography.Link>
								<Typography.Link className="!text-white hover:!text-yellow-200" onClick={() => window.open('/cookie-policy', '_blank')}>Cookie Policy</Typography.Link>
							</Space>
						</div>
					</Content>
				</Layout>
			</div>
		</Spin>
	);
};

export default Login;
